import gql from 'graphql-tag'

const connectToPlaid = gql`
  mutation connectToPlaid(
    $id: ID!
    $publicToken: String!
    $isUpdateMode: Boolean
    $isBankVerification: Boolean
    $isPendingAssetReport: Boolean
  ) {
    initializePlaidConnection(
      id: $id
      publicToken: $publicToken
      isUpdateMode: $isUpdateMode
      isBankVerification: $isBankVerification
      isPendingAssetReport: $isPendingAssetReport
    ) {
      access_token
      isAuthEnabled
      institution {
        institution_id
        name
        logo
      }
      checkingAccounts {
        account_id
        mask
        name
        official_name
        subtype
        type
        balances {
          current
          available
          limit
          iso_currency_code
        }
        numbers {
          account
          routing
        }
      }
      assetReport {
        asset_report_id
        asset_report_token
      }
      authStatus
      publicToken
    }
  }
`

const createPlaidLinkToken = gql`
  mutation createPlaidToken(
    $id: ID!
    $clientName: String
    $linkCustomizationName: String
    $redirectUrl: String
    $isBankVerification: Boolean
  ) {
    createPlaidToken(
      id: $id
      clientName: $clientName
      linkCustomizationName: $linkCustomizationName
      redirectUrl: $redirectUrl
      isBankVerification: $isBankVerification
    ) {
      expiration
      link_token
      request_id
    }
  }
`

export default {
  connectToPlaid,
  createPlaidLinkToken,
}

export {
  connectToPlaid,
  createPlaidLinkToken,
}
